export enum UserAccess {
  Free = 'Free',
  Premium = 'Premium',
  Founder = 'Founder',
}


export interface AuthInfos {
  userAccess: UserAccess,
  userAirTableId: string,
  userEmail: string,
}